import { Project } from "interfaces";

import Tag from "ui-components/Tag";

import { NotebookAnalysisProject } from "flows/notebook-analysis/interfaces";

const ContextSummary = ({ project }: { project: Project }) => {
  const metaData = (project as NotebookAnalysisProject).meta_data;
  const dissolution = metaData.dissolution;

  const counts = metaData.dissolution?.counts;

  return (
    <div className="mx-1">
      <div className="flex flex-wrap mb-2">
        Notebook{metaData["notebook-counts"].length === 1 ? "" : "s"}:{" "}
        {metaData["notebook-counts"]
          .sort((a, b) => b.count - a.count)
          .map(({ notebook, count }) => (
            <Tag key={notebook}>
              {notebook} ({count} experiments)
            </Tag>
          ))}
      </div>

      {counts && dissolution && (
        <div className="mb-2">
          <p className="underline">Dissolution Data</p>
          <p className="ml-2">
            Dissolution Data contained{" "}
            {counts.starting_profiles.toLocaleString()} profiles across{" "}
            {counts.starting_experiments.toLocaleString()} experiments.
            {counts["experiments-with-no-formulations-data"] >= 1 && (
              <span>
                {" "}
                However,{" "}
                {counts[
                  "experiments-with-no-formulations-data"
                ].toLocaleString()}{" "}
                experiments (
                {counts["profiles-with-no-formulations-data"].toLocaleString()}{" "}
                profiles) had no formulations data.
              </span>
            )}
          </p>
          {counts["total_errors"] > 0 && (
            <p className="ml-2">
              {counts["profiles-with-no-formulations-data"] >= 1
                ? "In addition to this, another"
                : "However,"}{" "}
              {counts["total_errors"].toLocaleString()} profiles had invalid
              data, i.e., dissolution greater than 120, or dissolution actually
              decreasing over time.
            </p>
          )}
          <div className="flex flex-wrap ml-2 mt-2">
            Unit Operations:{" "}
            {Object.entries(dissolution["unit-ops"]).map(([unit, d]) => (
              <Tag key={unit}>
                {unit} ({d.profile_count.toLocaleString()} profiles /{" "}
                {d.experiment_count.toLocaleString()} experiments)
              </Tag>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContextSummary;
